import type { NgZone } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { isDefined } from '@freelancer/utils';
import { Observable } from 'rxjs';

export const TESTING_IDLE_OPERATOR_MOCK = new InjectionToken<typeof idle>(
  'idle',
);

/**
 * Create an observable that emits an empty value and complete itself when browser idle.
 * Reference: https://ncjamieson.com/how-to-use-requestidlecallback/
 */
export function idle(ngZone: NgZone): Observable<void> {
  return new Observable<void>(observer => {
    if (window) {
      let handle: number;
      // Anything in the idle callback should not be essential for
      // page rendering, so we schedule it outside the angular zone.
      ngZone.runOutsideAngular(() => {
        handle = window.requestIdleCallback(() => {
          observer.next();
          observer.complete();
        });
      });
      return () => {
        if (isDefined(handle)) {
          window.cancelIdleCallback(handle);
        }
      };
    }
  });
}
